document.addEventListener("DOMContentLoaded", function () {
  const slider = document.getElementById("collection-slider");
  const prevButton = document.querySelector(".slider-arrow--prev");
  const nextButton = document.querySelector(".slider-arrow--next");

  if (window.innerWidth > 749) { // Apply only for desktop
    setupInfiniteScroll();
  }

  function setupInfiniteScroll() {
    const items = [...slider.children];
    const totalItems = items.length;

    // Duplicate all slides **initially**
    items.forEach(item => {
      const clone = item.cloneNode(true);
      clone.classList.add("cloned");
      slider.appendChild(clone);
    });

    // Set initial scroll position (middle of the looped items)
    slider.scrollLeft = slider.scrollWidth / 2;

    // Listen for scroll events and add more clones dynamically
    slider.addEventListener("scroll", function () {
      if (slider.scrollLeft <= 0) {
        // Reset scroll position to avoid abrupt jumps
        slider.scrollLeft = slider.scrollWidth / 2;
      } else if (slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 1) {
        // Append new clones dynamically
        items.forEach(item => {
          const clone = item.cloneNode(true);
          clone.classList.add("cloned");
          slider.appendChild(clone);
        });
      }
    });
  }

  function smoothScroll(direction) {
    const scrollAmount = 300; // Adjust based on card width
    slider.scrollBy({ left: direction * scrollAmount, behavior: "smooth" });
  }

  prevButton.addEventListener("click", () => smoothScroll(-1));
  nextButton.addEventListener("click", () => smoothScroll(1));
});
